import React, { useState } from 'react';
import * as styles from './carouselTextOver.module.scss';

interface CarouselItem {
  imageSrc: string;
  imageAlt?: string;
  title?: string;
  description?: string;
}

interface CarouselTextOverProps {
  items?: CarouselItem[];
}

export default ({ block }) => {
  const items = block.items || [];
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? items.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === items.length - 1 ? 0 : prev + 1));
  };

  const currentItem = items[currentIndex];

  return (
    <div className={styles.section}>
      <div className={styles.carouselRow}>
        <button onClick={handlePrev} className={styles.navButton} aria-label="Previous Slide">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="#002b5c" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        <div className={styles.imageWrapper}>
          <div className={styles.topLeftDecoration} />
          <img 
            src={currentItem.imageSrc} 
            alt={currentItem.imageAlt || currentItem.title} 
            className={styles.image} 
          />
          
          <div className={styles.textOverlay}>
            {currentItem.title && (
              <h3 className={styles.title}>{currentItem.title}</h3>
            )}
            {currentItem.description && (
              <p className={styles.description}>{currentItem.description}</p>
            )}
          </div>

          <div className={styles.bottomRightDecoration} />
        </div>

        <button onClick={handleNext} className={styles.navButton} aria-label="Next Slide">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="#002b5c" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  );
};